import type { Goal } from '../../types/timeline'

/**
 * How Review should react when the live timeline differs from its draft.
 * - 'none'   — nothing to do (sync off, or the draft already matches live).
 * - 'rebase' — no unsaved edits: replace working + baseline with live data.
 * - 'notify' — unsaved edits exist: keep the draft, tell the user updates are waiting.
 */
export type LiveReviewSyncDecision = 'none' | 'rebase' | 'notify'

export const goalsSignature = (goals: readonly Goal[] | null | undefined): string => JSON.stringify(goals ?? [])

export const decideLiveReviewSync = ({
  enabled,
  hasUnsaved,
  workingGoals,
  liveGoals,
}: {
  enabled: boolean
  hasUnsaved: boolean
  workingGoals: readonly Goal[] | null | undefined
  liveGoals: readonly Goal[] | null | undefined
}): LiveReviewSyncDecision => {
  if (!enabled || !liveGoals) return 'none'
  if (goalsSignature(workingGoals) === goalsSignature(liveGoals)) return 'none'
  return hasUnsaved ? 'notify' : 'rebase'
}
